/* eslint-disable @typescript-eslint/no-explicit-any */
import { computed } from 'vue';
import roleNameMap from '~packages/epk-roles/constants/roleNameMap.json';

import { useOrgStore } from '@/shared/model';

/**
 * Returns computed `role`, `roleName`
 */
export default () => {
  type Role = keyof typeof roleNameMap;

  const orgStore = useOrgStore();

  const arr = Object.keys(roleNameMap) as Role[];
  const role = computed(() =>
    arr.find(i => orgStore.userInfo.org_choose?.type_org_kk === i)
  );
  const roleName = computed(() =>
    typeof role.value === 'undefined' ? '' : roleNameMap[role.value]
  );

  return { role, roleName };
};
